import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../lib/api";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { GraduationCap, Play, Certificate } from "@phosphor-icons/react";
import { fmtDate } from "../../lib/dateUtil";

/** My Work card: courses assigned to me (with due dates), ones in progress, and passed certificates. */
export default function OperativeTrainingCard() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { API.get("/in-house-portal/training").then(({ data }) => setRows(data.assignments || [])).catch(() => setRows([])); }, []);
  if (!rows || rows.length === 0) return null;
  const todo = rows.filter(r => r.status !== "passed");
  const done = rows.filter(r => r.status === "passed");

  return (
    <div className="bg-card border border-border rounded-lg p-5 border-l-4 border-l-violet-500" data-testid="operative-training-card">
      <h2 className="text-lg font-semibold flex items-center gap-2 mb-3"><GraduationCap className="h-5 w-5 text-violet-600" weight="fill" /> My training</h2>
      <div className="space-y-2">
        {todo.map(r => (
          <div key={r.id} className="flex flex-wrap items-center gap-2 text-xs py-1.5 px-2 rounded hover:bg-muted" data-testid={`operative-training-${r.id}`}>
            <div className="flex-1 min-w-[180px]">
              <p className="font-medium leading-snug">{r.course.title}</p>
              <p className="text-[11px] text-muted-foreground">{r.course.module_count} module{r.course.module_count === 1 ? "" : "s"} · {r.course.question_count} question{r.course.question_count === 1 ? "" : "s"} · ~{r.course.duration_minutes} min{r.status === "failed" ? ` · last score ${r.best_score}%` : ""}</p>
            </div>
            {r.due_date && <Badge className={`text-[10px] ${r.overdue ? "bg-red-100 text-red-700" : "bg-slate-100 text-slate-700"}`}>{r.overdue ? "overdue · " : "by "}{fmtDate(r.due_date)}</Badge>}
            <Button size="sm" className="h-7" onClick={() => navigate(`/my-work/training/${r.id}`)} data-testid={`operative-training-start-${r.id}`}><Play size={12} className="mr-1" /> {r.status === "assigned" ? "Start" : r.status === "failed" ? "Retry" : "Continue"}</Button>
          </div>
        ))}
        {done.length > 0 && (
          <div data-testid="operative-training-passed">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground mb-1 mt-2">Passed</p>
            {done.map(r => (
              <button key={r.id} type="button" onClick={() => navigate(`/my-work/training/${r.id}`)} className="w-full flex items-center gap-2 text-xs py-1 px-2 rounded hover:bg-muted text-left" data-testid={`operative-training-done-${r.id}`}>
                <Certificate size={14} className="text-emerald-600" />
                <span className="flex-1 truncate">{r.course.title}</span>
                <span className="text-muted-foreground">{r.best_score}% · {r.certificate_no}{r.expires_on ? ` · to ${fmtDate(r.expires_on)}` : ""}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
